import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface MetricCardProps {
  value: number;
  total?: number;
  label: string;
  tooltip: string;
  percentage: string;
  color: "emerald" | "blue" | "amber" | "rose";
}

const colorClasses = {
  emerald: {
    dot: "bg-emerald-500",
    text: "text-emerald-600",
  },
  blue: {
    dot: "bg-blue-400",
    text: "text-blue-400",
  },
  amber: {
    dot: "bg-amber-500",
    text: "text-amber-600",
  },
  rose: {
    dot: "bg-rose-500",
    text: "text-rose-600",
  },
};

export function MetricCard({
  value,
  total,
  label,
  tooltip,
  percentage,
  color,
}: MetricCardProps) {
  const colorClass = colorClasses[color];

  return (
    <div className="h-8 w-full flex flex-row justify-start items-center gap-2 px-2.5 bg-chrome text-sm font-medium border-b border-r group">
      <span className={`${colorClass.text} font-mono`}>{percentage}%</span>
      <span className="flex flex-row items-center gap-2">
        {label}
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <Info className="size-3 text-muted-foreground cursor-help opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100"/>
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-52 w-auto text-center text-balance">{tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </span>
      <span className="font-mono ml-auto flex flex-row items-center gap-1">
        <span>{value}</span>
        <span>/</span>
        <span className="flex flex-row items-center">{total}</span>
      </span>
    </div>
  );
}
